import { Profile } from "~/models/profile";
import { ProfileCard } from "./ProfileCard";
import { Logger } from "~/utils/logger";

const logger = new Logger("ProfileCards", "info");

export const ProfileCards = ({ profiles }: { profiles: Profile[] | null }) => {
  logger.debug("profiles:", profiles);
  return (
    <div className="tw:gap-10 tw:grid tw:grid-cols-1 tw:md:grid-cols-2 tw:lg:grid-cols-3 tw:place-items-center">
      {profiles?.map((profile: Profile) => (
        <ProfileCard
          key={`${profile.firstName}-${profile.lastName}`}
          name={`${profile.firstName} ${profile.lastName}`}
          title={profile.subTitle || profile.title} // use subTitle if specified, otherwise fall back to title
          bio={profile.bio}
          image={profile.image}
        />
      ))}
    </div>
  );
};
